import { formatInTimeZone } from 'date-fns-tz';
import { map } from 'lodash-es';
import { TimeZoneDto } from '../models/dto';
import { TimeZonesEnum } from '../enums';

export const getTimeZones = (startDate?: Date | null, timeZone?: string) => {
	const referenceDate = startDate ?? new Date();

	// To get the standard time zone offset ignoring daylight saving time.
	const {
		tzid: localTimeZone,
		abbr: localTimeZoneAbbr,
		offset: localTimeZoneOffset,
	} = getLocalTimeZoneInfo(referenceDate);

	const timeZones = Object.values(TimeZonesEnum)
		.reduce<Record<string, TimeZoneDto>>((acc, timeZone) => ({
			...acc,
			[timeZone]: getTimeZoneAbbrAndOffset(referenceDate, timeZone),
		}), {});
	const timeZoneAbbreviations = map(timeZones, ({ abbr }) => abbr);

	if (!timeZoneAbbreviations.includes(localTimeZoneAbbr)) {
		timeZones[localTimeZone] = {
			abbr: localTimeZoneAbbr,
			offset: localTimeZoneOffset,
		};
		timeZoneAbbreviations.push(localTimeZoneAbbr);
	}

	if (timeZone) {
		const { abbr: timeZoneAbbr, offset: timeZoneOffset } = getTimeZoneAbbrAndOffset(referenceDate, timeZone);

		if (!timeZoneAbbreviations.includes(timeZoneAbbr)) {
			timeZones[timeZone] = {
				abbr: timeZoneAbbr,
				offset: timeZoneOffset,
			};
			timeZoneAbbreviations.push(timeZoneAbbr);
		}
	}

	return timeZones;
};

export const getTimeZoneAbbrAndOffset = (referenceDate: Date, timeZone: string) => ({
	abbr: formatInTimeZone(referenceDate, timeZone, 'zzz'),
	offset: formatInTimeZone(referenceDate, timeZone, 'XXX'),
});

export const getLocalTimeZone = () => Intl.DateTimeFormat().resolvedOptions().timeZone || TimeZonesEnum.Central;

export const getLocalTimeZoneInfo = (referenceDate: Date) => {
	const localTimeZone = getLocalTimeZone();

	const { abbr: localTimeZoneAbbr, offset: localTimeZoneOffset } = getTimeZoneAbbrAndOffset(
		referenceDate,
		localTimeZone
	);

	return {
		tzid: localTimeZone,
		abbr: localTimeZoneAbbr,
		offset: localTimeZoneOffset,
	};
};
